import { useCallback, useState } from 'react';

import { XMarkIcon } from '@heroicons/react/24/outline';

import { cls } from '@/utils/cls';

export function KaiRail() {
  const [open, setOpen] = useState(false);

  const handleClose = useCallback(() => setOpen(false), []);
  const handleOpen = useCallback(() => setOpen(true), []);

  return (
    <>
      <div
        className={cls(
          'relative flex-shrink-0 flex flex-col overflow-hidden',
          'bg-[rgba(39,68,131,0.82)] backdrop-blur-xl saturate-150',
          'border-l border-white/15',
          'shadow-[-2px_0_18px_rgba(39,68,131,0.25),inset_1px_0_0_rgba(255,255,255,0.08)]',
          'transition-[width] duration-[220ms] ease-[cubic-bezier(0.4,0,0.2,1)]',
          open ? 'w-[220px]' : 'w-0',
        )}
      >
        {/* Fixed-width inner wrapper so content doesn't squish during transition */}
        <div className="w-[220px] flex flex-col h-full">
          <div className="flex items-center gap-2 p-3 relative flex-shrink-0 border-b border-white/[0.12]">
            <div className="flex items-center justify-center w-[42px] h-[42px] rounded-full text-[11px] font-extrabold tracking-tight flex-shrink-0 bg-[#F5F6F8] text-[#274483]">
              KAI
            </div>
            <span className="text-white font-bold text-[12.5px] leading-tight">Your supply chain assistant</span>
            <button
              onClick={handleClose}
              aria-label="Close Kai"
              className="absolute top-2 right-2 flex items-center justify-center w-6 h-6 rounded bg-white/[0.06] border border-white/[0.12] text-white/70 hover:text-white transition-colors cursor-pointer"
            >
              <XMarkIcon className="size-3.5" />
            </button>
          </div>

          <div className="flex-1 overflow-hidden" />
        </div>
      </div>

      {!open && (
        <button
          onClick={handleOpen}
          aria-label="Open Kai"
          className="fixed bottom-6 right-6 w-[52px] h-[52px] rounded-full bg-gradient-to-br from-[#4A6BAD] to-[#274483] border border-[#4A6BAD]/50 shadow-[0_4px_24px_rgba(39,68,131,0.45),0_0_0_1px_rgba(255,255,255,0.08)] text-white text-[11px] font-extrabold tracking-[-0.5px] cursor-pointer z-[999] transition-transform duration-150 hover:scale-[1.08]"
        >
          KAI
        </button>
      )}
    </>
  );
}
